import { Alert, WithScrollIntoView } from '@ctct/presentation-layer';
import type { AlertHooks } from '@ctct/state-client-layer';

interface Props {
  hooks: AlertHooks;
}

export const AlertWidgetContent = ({ hooks }: Props) => {
  const alerts = hooks.useAlerts();

  return alerts.map((alert, i) => {
    const isFirst = i === 0;
    const { message, variant, header, id } = alert;

    if (isFirst) {
      return (
        <WithScrollIntoView key={id}>
          <Alert message={message} variant={variant} header={header} />
        </WithScrollIntoView>
      );
    }

    return <Alert message={message} variant={variant} header={header} key={id} />;
  });
};
